<template>
    <div style="padding: 40px">
        <Row :gutter="20">
            <Col span="6">
                <div class="home-item">
                    <p class="home-title">项目总数（个）</p>
                    <p class="home-value">{{info.projCount || 0}}</p>
                    <div class="home-icon bg1">
                        <common-icon type="_shouye-xiangmuzongshu" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
            <Col span="6">
                <div class="home-item">
                    <p class="home-title">微信客户（人）</p>
                    <p class="home-value">{{info.wxCustomerCount || 0}}</p>
                    <div class="home-icon bg2">
                        <common-icon type="_shouye-kehuzongshu" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
            <Col span="6">
                <div class="home-item">
                    <p class="home-title">订单总数（个）</p>
                    <p class="home-value">{{info.orderCount || 0}}</p>
                    <div class="home-icon bg3">
                        <common-icon type="_shouye-dingdanzongshu" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
            <Col span="6">
                <div class="home-item">
                    <p class="home-title">认购金额（万元）</p>
                    <p class="home-value">{{info.payAmount | currency}}</p>
                    <div class="home-icon bg4">
                        <common-icon type="_shouye-rengoujine" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
            <Col span="6" style="margin-top: 20px;">
                <div class="home-item">
                    <p class="home-title">置业顾问（个）</p>
                    <p class="home-value">{{info.adviserCount | 0}}</p>
                    <div class="home-icon bg1">
                        <common-icon type="_guwenguanli" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
            <Col span="6" style="margin-top: 20px;">
                <div class="home-item">
                    <p class="home-title">经纪人数（个）</p>
                    <p class="home-value">{{info.brokerCount | 0}}</p>
                    <div class="home-icon bg2">
                        <common-icon type="_jingjiguanli" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
            <Col span="6" style="margin-top: 20px;">
                <div class="home-item">
                    <p class="home-title">全民客户（个）</p>
                    <p class="home-value">{{info.customerCount | 0}}</p>
                    <div class="home-icon bg2">
                        <common-icon type="_shouye-kehuzongshu" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
            <Col span="6" style="margin-top: 20px;">
                <div class="home-item">
                    <p class="home-title">到访总数（个）</p>
                    <p class="home-value">{{info.visitCount | 0}}</p>
                    <div class="home-icon bg4">
                        <common-icon type="_dagou" color="#fff" :size="32"></common-icon>
                    </div>
                </div>
            </Col>
        </Row>
        <div class="home-chart-container">
            <p class="home-chart-title">最近30天访问量</p>
            <div class="home-chart-box">
                <line-chart :list="list" chartName="访问量"></line-chart>
            </div>
        </div>
    </div>
</template>
<script>
import { sellStatistic, viewStatistic } from '@/api/home'
import { ymdL, ymd } from '_u/helper'
import LineChart from '_v/components/chart/line-chart-normal'

import dayjs from "dayjs"
import weekOfYear from "dayjs/plugin/weekOfYear"

dayjs.extend(weekOfYear)
window.t = dayjs

export default {
    name: 'IndexHome',
    data() {
        return {
            info: {
                projCount: '',      // 项目总数
                wxCustomerCount: '',// 客户总数
                orderCount: '',     // 订单总数
                payAmount: '',      // 认购金额(元)
                adviserCount: '',   // 置业顾问总数
                brokerCount: '',    // 经纪人总数
                customerCount: '',  // 全民客户总数
                visitCount: ''      // 到访总数
            },
            list: []
        }
    },
    components: { LineChart },
    methods: {
        setData(args) {
            let [info, list] = args
            info.data.payAmount = info.data.payAmount
                ? parseFloat(info.data.payAmount) / 10000
                : 0
            Object.keys(this.info).forEach(key => {
                this.info[key] = info.data[key] || ''
            })
            let resList = list.data.list,
                chartList = [],
                map = {}
            resList.forEach(el => {
                let date = ymd(el.dateTime)
                if (map[date]) {
                    let item = chartList.find(val => val.name == date) || {}
                    item.value++
                } else {
                    chartList.push({
                        value: parseInt(el.totalCount),
                        name: date
                    })
                    map[date] = true
                }
            })
            this.list = chartList.sort((a, b) => {
                if (a.name > b.name) {
                    return 1
                } else {
                    return -1
                }
            })
        }
    },
    created() {},
    beforeRouteEnter(to, from, next) {
        Promise.all([sellStatistic(), viewStatistic()]).then(args => {
            next(vm => vm.setData(args))
        })
    }
}
</script>
<style lang="less" scoped>
@title-color: #515a6e;
.home {
    &-item {
        position: relative;
        height: 130px;
        padding: 30px;
        border: 1px solid @link-color;
        border-radius: 4px;
        background-color: #fff;
    }
    &-title {
        font-size: 14px;
        color: @title-color;
    }
    &-value {
        font-size: 28px;
        font-weight: bold;
        color: @link-color;
        line-height: 70px;
    }
    &-icon {
        position: absolute;
        width: 56px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        border-radius: 50%;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        &.bg1 {
            background-color: #f5365c;
        }
        &.bg2 {
            background-color: #fb6340;
        }
        &.bg3 {
            background-color: #ffd600;
        }
        &.bg4 {
            background-color: #11cdef;
        }
    }
    &-chart {
        &-container {
            margin-top: 20px;
            background-color: #fff;
            padding: 20px;
        }
        &-box {
            height: 300px;
        }
        &-title {
            color: #333333;
            line-height: 48px;
            font-size: 14px;
        }
    }
}
</style>
